import { apiSlice } from "../../api/api";

export const allusersApi = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getallusers: builder.query({
      query: (params = {}) => ({
        url: "/operations/allusers",
        method: "GET",
        params: {
          page: params.page || 1,
          search: params.search || "",
          ...params,
        },
      }),
      providesTags: ["AllUsers"],
    }),
  }),
});

export const { useGetallusersQuery } = allusersApi;
